import { Skeleton } from '@music-vine/cadence/ui';

/**
 * Loading state for the code-split download screens (DEV-6485). The screens
 * chunk is fetched on the first download click, so without this the dialog
 * (or drawer) opens as an empty shell for as long as the request takes.
 *
 * Mirrors the first screen's shape — asset header, then the download CTA —
 * so the surface opens at roughly its final height instead of popping.
 */
export const ConfirmDownloadScreensSkeleton = () => <div aria-label="Loading download options" aria-live="polite" role="status" data-sentry-component="ConfirmDownloadScreensSkeleton" data-sentry-source-file="screens-skeleton.tsx">
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <Skeleton className="size-16 shrink-0 rounded-full" data-sentry-element="Skeleton" data-sentry-source-file="screens-skeleton.tsx" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-5 w-2/3" data-sentry-element="Skeleton" data-sentry-source-file="screens-skeleton.tsx" />
          <Skeleton className="h-4 w-1/3" data-sentry-element="Skeleton" data-sentry-source-file="screens-skeleton.tsx" />
        </div>
      </div>
      <Skeleton className="h-12 w-full rounded-xl" data-sentry-element="Skeleton" data-sentry-source-file="screens-skeleton.tsx" />
    </div>
  </div>;